import React, { useEffect, useState } from 'react';

import { useStateContext } from './context';
import { loadGoogleMaps } from './utils';
import { AppView } from './components/AppView';

export const App = () => {
    const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false);
    const { isMobile, fetchAvailableStores } = useStateContext();

    useEffect(() => {
        fetchAvailableStores();
    }, []);

    useEffect(() => {
        // Set callback function
        window.initMap = () => {
            setGoogleMapsLoaded(true);
        };

        loadGoogleMaps();
    }, [setGoogleMapsLoaded]);

    return <>{!!(googleMapsLoaded && isMobile !== undefined) && <AppView />}</>;
};
